define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.setLocalStorageValue = exports.getLocalStorageValue = exports.isLocalStorageSupported = void 0;
    function isLocalStorageSupported() {
        try {
            return 'localStorage' in window && window['localStorage'] !== null;
        }
        catch (e) {
            console.warn("LocalStorage not supported", e);
            return false;
        }
    }
    exports.isLocalStorageSupported = isLocalStorageSupported;
    function getLocalStorageValue(k) {
        try {
            let v = isLocalStorageSupported() && localStorage.getItem(k);
            if (!!v && v != "undefined" && v != "null") {
                return v;
            }
        }
        catch (err) {
            console.error(`LocalStorage: Could not read ${k} from LocalStorage`, err);
        }
        return null;
    }
    exports.getLocalStorageValue = getLocalStorageValue;
    function setLocalStorageValue(k, v) {
        try {
            if (isLocalStorageSupported()) {
                localStorage.setItem(k, v);
            }
        }
        catch (err) {
            console.error(`LocalStorage: Could not set ${k} to ${v}`, err);
        }
        return null;
    }
    exports.setLocalStorageValue = setLocalStorageValue;
});
